import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-ophthalmology-report',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './ophthalmology-report.component.html',
  styleUrls: ['./ophthalmology-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphthalmologyReportComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  findingsRows = [
    { k: 'vital_functions', key: 'ophthalmology.vital_functions' },
    { k: 'tear_production', key: 'ophthalmology.tear_production' },
    {
      k: 'intraocular_pressure',
      key: 'ophthalmology.intraocular_pressure',
    },
    { k: 'vision', key: 'ophthalmology.vision' },
    {
      k: 'photopic_optic_reflex',
      key: 'ophthalmology.photopic_optic_reflex',
    },
    {
      k: 'pupillary_light_reflex',
      key: 'ophthalmology.pupillary_light_reflex',
    },
    { k: 'indirect_plr', key: 'ophthalmology.indirect_plr' },
    {
      k: 'palpebral_corneal_reflex',
      key: 'ophthalmology.palpebral_corneal_reflex',
    },
    { k: 'globe_orbit', key: 'ophthalmology.globe_orbit' },
    {
      k: 'motility_retropulsion',
      key: 'ophthalmology.motility_retropulsion',
    },
    { k: 'eyelids', key: 'ophthalmology.eyelids' },
    { k: 'conjunctiva', key: 'ophthalmology.conjunctiva' },
    { k: 'cornea', key: 'ophthalmology.cornea' },
    { k: 'anterior_chamber', key: 'ophthalmology.anterior_chamber' },
    { k: 'iris', key: 'ophthalmology.iris_pupil' },
    { k: 'lens', key: 'ophthalmology.lens' },
    { k: 'vitreous', key: 'ophthalmology.vitreous' },
    {
      k: 'retina_optic_nerves',
      key: 'ophthalmology.retina_optic_nerves',
    },
  ];

  override ngOnInit(): void {
    this.form = this.fb.group({
      diagnosis_eyelids_left: [''],
      diagnosis_eyelids_right: [''],
      diagnosis_anterior_chamber_left: [''],
      diagnosis_anterior_chamber_right: [''],
      diagnosis_lens_left: [''],
      diagnosis_lens_right: [''],
      diagnosis_vitreous_left: [''],
      diagnosis_vitreous_right: [''],
      diagnosis_iris_left: [''],
      diagnosis_iris_right: [''],

      history: [''],

      findings_vital_functions_left: [''],
      findings_vital_functions_right: [''],
      findings_tear_production_left: [''],
      findings_tear_production_right: [''],
      findings_intraocular_pressure_left: [''],
      findings_intraocular_pressure_right: [''],
      findings_vision_left: [''],
      findings_vision_right: [''],
      findings_photopic_optic_reflex_left: [''],
      findings_photopic_optic_reflex_right: [''],
      findings_pupillary_light_reflex_left: [''],
      findings_pupillary_light_reflex_right: [''],
      findings_indirect_plr_left: [''],
      findings_indirect_plr_right: [''],
      findings_palpebral_corneal_reflex_left: [''],
      findings_palpebral_corneal_reflex_right: [''],
      findings_globe_orbit_left: [''],
      findings_globe_orbit_right: [''],
      findings_motility_retropulsion_left: [''],
      findings_motility_retropulsion_right: [''],
      findings_eyelids_left: [''],
      findings_eyelids_right: [''],
      findings_conjunctiva_left: [''],
      findings_conjunctiva_right: [''],
      findings_cornea_left: [''],
      findings_cornea_right: [''],
      findings_anterior_chamber_left: [''],
      findings_anterior_chamber_right: [''],
      findings_iris_left: [''],
      findings_iris_right: [''],
      findings_lens_left: [''],
      findings_lens_right: [''],
      findings_vitreous_left: [''],
      findings_vitreous_right: [''],
      findings_retina_optic_nerves_left: [''],
      findings_retina_optic_nerves_right: [''],

      plan_recommendations: [''],
      ocular_medications: [''],
      systemic_medications: [''],
      // camelCase aliases used by the template
      planRecommendations: [''],
      ocularMedications: [''],
      systemicMedications: [''],
      note: [''],
      veterinarianName: [''],
    });

    this.formChange.emit(this.form.value);
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );

    super.ngOnInit();
  }
}
